import { LovItem } from "core/metamodel/mdEntity";
import { DomainAncestor, entityConfig, fieldInfo } from "core/common/domain/DomainAncestor";
import { ID, EntityConfig } from "core/metamodel/metaConstant";
import { observable } from "mobx";
import { ValidEntityIntf } from "core/common/domain/commonDomain";
import { blue500, red500, green500, orange500 } from "material-ui/styles/colors";



export enum PRICECOMPLEVEL {
  PRODUCT = 'PRODUCT',
  PRODUCTCUSTGROUP = 'PRODUCTCUSTGROUP',
  PRODUCTCUSTOMER = 'PRODUCTCUSTOMER',
  PRODUCTVEHICLE = 'PRODUCTVEHICLE'
}

export const PRICECOMPLEVEL_COLORS = {
  PRODUCT: green500,
  PRODUCTCUSTGROUP: orange500,
  PRODUCTCUSTOMER: blue500,
  PRODUCTVEHICLE: red500
};

export const PROFITCENTER = {
  DYNAFLEET: 1,
  OPTIFLEET: 2
};


export interface Price {
  price: number;
  currency: string;
}


@entityConfig(class extends EntityConfig {
  constructor() {
    super("PriceComponent");
  }
  getFormName(historyObject) {
    return (historyObject.parentEntityName === 'Vehicle') ? "PriceComponentAssignedForm"
      : ((historyObject.parentEntityName === 'Product') ? "PriceComponentProductForm" : "PriceComponentForm");
  }
})
export class PriceComponent extends DomainAncestor {

  @observable priceComponentId?: number;
  @observable priceLevel?: LovItem;
  @observable product?: LovItem;
  @observable vehicle?: LovItem;
  @observable party?: LovItem;
  @observable priceCurrency?: LovItem;

  @observable price?: number;
  @observable profitCenter?: LovItem;
  @observable priceLcy?: number;
  @observable validFrom?: string | Date;
  @observable validTo?: string | Date;
  @observable comment?: string;

  constructor(json: any) {
    super(json);
  }


  public getId(): ID {
    return this.priceComponentId;
  }

  public setId(id: ID): void {
    this.priceComponentId = <any>id;
  }

}



@entityConfig()
export class ProductVehicle extends DomainAncestor implements ValidEntityIntf {

  @observable product?: LovItem;
  @observable vehicle?: LovItem;
  @observable validFrom?: string | Date;
  @observable validTo?: string | Date;
  @observable validPrice?: Price;

  // prices se nesmi inicializovat, protoze se lazy loduji v VehicleDetail#onProductVehicleFormLoad()  - nejsou soucasti ProductVehicle objektu
  @observable @fieldInfo(PriceComponent) prices?: PriceComponent[];

  @observable activePriceComponentId?: number;

  constructor(json: any) {
    super(json);
  }
}


@entityConfig(undefined, "vehicleDetail")
export class Vehicle extends DomainAncestor {

  @observable vehicleId: number;
  @observable registrationNumber: string;
  @observable vin: string;
  @observable chassis: string;
  @observable chassisSeries: string;
  @observable model: string;
  @observable party: LovItem;
  @observable vehicleType: LovItem | number;
  @observable vehicleBrand: LovItem;
  @observable vehicleNumber: string;
  @observable activationDate: string | Date;
  @observable active: boolean;
  @observable note: string;
  @observable operatorParty: LovItem;
  @observable driverParty: LovItem;
  @observable closeDate: string | Date;
  @observable lastNotificationCheck: string | Date;
  @observable sourceSystemDate: string | Date;
  @observable @fieldInfo(ProductVehicle) productVehicles: ProductVehicle[];

  constructor(json: any) {
    super(json);

    if (!this.productVehicles) this.productVehicles = [];
  }


  public getId(): ID {
    return this.vehicleId;
  }

  public setId(id: ID): void {
    this.vehicleId = id as any;
  }

}


@entityConfig()
export class Product extends DomainAncestor {
  @observable productId?: number;
  @observable productNumber?: string;
  @observable name?: string;
  @observable productType?: LovItem;
  @observable specification?: string;
  @observable comment?: string;
  @observable introductionDate?: string | Date;
  @observable salesDiscontinuationDate?: string | Date;
  @observable supportDiscontinuationDate?: string | Date;
  @observable unitOfMeasure?: LovItem;
  @observable profitCenter?: LovItem;
  @observable revenueCategory?: LovItem;
  @observable vatRate?: LovItem;
  @observable closeDate: string | Date;
  @observable taxType: LovItem;

  @observable @fieldInfo(PriceComponent) prices?: PriceComponent[];


  constructor(json: any) {
    super(json);

    if (!this.prices) this.prices = [];
  }

  public getId(): ID {
    return this.productId;
  }

  public setId(id: ID): void {
    this.productId = id as any;
  }

}






// WEBPACK FOOTER //
// ./src/product/productDomain.ts